import type { TagItem, WorkItem } from "../types/work";

/** ジャンル（カテゴリ）として扱うタグ */
export const GENRE_TAGS = ["#謎解き", "#ボードゲーム", "#言葉遊び"] as const;

/** 形式として扱うタグ */
export const FORMAT_TAGS = [
  "#ホール型",
  "#ルーム型",
  "#ブース型",
  "#周遊型",
  "#キット型",
  "#WEB型",
  "#カフェ型",
] as const;

export type GenreTag = (typeof GENRE_TAGS)[number];
export type FormatTag = (typeof FORMAT_TAGS)[number];

export function getTagLabel(tag: TagItem): string {
  return typeof tag === "string" ? tag : tag.label;
}

export function workHasTag(work: WorkItem, label: string): boolean {
  return work.tags.some((t) => getTagLabel(t) === label);
}

/** データ上に実際に存在するタグだけを、定義順で返す */
export function collectPresentTags(
  works: WorkItem[],
  candidates: readonly string[],
): string[] {
  return candidates.filter((label) => works.some((w) => workHasTag(w, label)));
}

export function filterWorks(
  works: WorkItem[],
  genre: string | null,
  format: string | null,
): WorkItem[] {
  return works.filter((w) => {
    if (genre && !workHasTag(w, genre)) return false;
    if (format && !workHasTag(w, format)) return false;
    return true;
  });
}
